/* import __COLOCATED_TEMPLATE__ from './dialog.hbs.js'; */
import { assert } from '@ember/debug';
import Component from '@glimmer/component';
export default class DialogComponent extends Component {
  constructor() {
    super(...arguments);
    assert('<Dialog /> You must provide either @title or @ariaLabel for accessibility.', this.args.title || this.args.ariaLabel);
  }
}